<template>
  <BaseDialogForm
    v-model="showFieldConfigurationForm"
    :title="
      editMode
        ? `Edit ${configurationModule.fieldConfiguration}`
        : `Add ${configurationModule.fieldConfiguration}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="fieldConfigurationForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12" lg="4">
            <SelectField
              id="configModule"
              v-model="configModule"
              :itemsList="moduleList"
              name="configModule"
              itemText="name"
              itemValue="id"
              :label="`${configurationModule.configuration} Module*`"
              :rules="[(val) => !!val || 'Configuration Module is required']"
              @change="
                getModuleKeyWordList({ module: $event });
                fieldConfigurationDetails.keyword = null;
              "
            />
          </v-col>
          <v-col cols="12" lg="4">
            <SelectField
              id="keyword"
              v-model="fieldConfigurationDetails.keyword"
              name="keyword"
              label="Keyword*"
              :itemsList="moduleKeyWordList"
              itemText="name"
              itemValue="id"
              :rules="[(val) => !!val || 'Keyword is required']"
              :error-messages="formErrors.keyword"
              @input="delete formErrors.keyword"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="name"
              v-model="fieldConfigurationDetails.name"
              label="Label"
              :required="true"
              name="name"
              :rules="[
                (val) => {
                  return (
                    !(/[0-9]/gi.test(val) && !/[a-z]/gi.test(val)) ||
                    'Label can not be just numbers!'
                  );
                },
                (v) =>
                  !/[^a-zA-Z0-9 _.-]/.test(v) ||
                  'Special characters are not allowed',
              ]"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
          <v-col cols="12">
            <InputField
              id="description"
              v-model="fieldConfigurationDetails.description"
              label="Description"
              name="description"
              :error-messages="formErrors.description"
              @input="delete formErrors.description"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="fieldConfigurationReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="fieldConfigurationSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseDialogForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    fieldConfigurationID: {
      type: Number,
    },
  },
  data() {
    return {
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      fieldConfigurationDetails: {},
      formErrors: {},
      moduleKeyWordList: [],
      moduleList: [],
      configModule: null,
    };
  },
  watch: {
    async value(val) {
      if (val) {
        await this.getModuleList();
        if (this.editMode && this.fieldConfigurationID) {
          await this.getFieldConfigurationObject(this.fieldConfigurationID);
        }
      } else {
        this.resetForm();
        this.formErrors = {};
      }
    },
  },
  computed: {
    showFieldConfigurationForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.fieldConfigurationDetails = {};
      this.$refs.fieldConfigurationForm.reset();
    },
    async getFieldConfigurationObject(id) {
      await this.$api.fieldConfiguration
        .getFieldConfigurationObject(id)
        .then((res) => {
          this.fieldConfigurationDetails = res.data;
          this.configModule = res.data.module;
          this.getModuleKeyWordList({ module: res.data.module });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getModuleList() {
      bus.$emit("showLoader", true);
      await this.$api.module
        .getModuleList({
          limit: "all",
        })
        .then((res) => {
          this.moduleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getModuleKeyWordList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.module
        .getModuleKeyWordList(params)
        .then((res) => {
          this.moduleKeyWordList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    submitForm() {
      if (!this.$refs.fieldConfigurationForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      if (this.editMode) {
        this.$api.fieldConfiguration
          .updateFieldConfigurationObject(
            this.fieldConfigurationDetails.id,
            this.fieldConfigurationDetails
          )
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Field Configuration information updated!",
              color: "success",
            });
            this.$emit("refreshList");
            this.showFieldConfigurationForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err.data;
          });
      } else {
        this.$api.fieldConfiguration
          .createFieldConfigurationObject(this.fieldConfigurationDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Field Configuration created!",
              color: "success",
            });
            this.showFieldConfigurationForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
